import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = function defaultMakeData() {
  return Object.create(null);
};
// Useful for processing arguments objects as well as arrays.
var _Array$prototype = Array.prototype,
  forEach = _Array$prototype.forEach,
  slice = _Array$prototype.slice;
var hasOwnProperty = Object.prototype.hasOwnProperty;
export var Trie = /*#__PURE__*/function () {
  function Trie() {
    var weakness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var makeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMakeData;
    _classCallCheck(this, Trie);
    this.weakness = weakness;
    this.makeData = makeData;
  }
  return _createClass(Trie, [{
    key: "lookup",
    value: function lookup() {
      for (var _len = arguments.length, array = new Array(_len), _key = 0; _key < _len; _key++) {
        array[_key] = arguments[_key];
      }
      return this.lookupArray(array);
    }
  }, {
    key: "lookupArray",
    value: function lookupArray(array) {
      var node = this;
      forEach.call(array, function (key) {
        return node = node.getChildTrie(key);
      });
      return hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData(slice.call(array));
    }
  }, {
    key: "peek",
    value: function peek() {
      for (var _len2 = arguments.length, array = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        array[_key2] = arguments[_key2];
      }
      return this.peekArray(array);
    }
  }, {
    key: "peekArray",
    value: function peekArray(array) {
      var node = this;
      for (var i = 0, len = array.length; node && i < len; ++i) {
        var map = this.weakness && isObjRef(array[i]) ? node.weak : node.strong;
        node = map && map.get(array[i]);
      }
      return node && node.data;
    }
  }, {
    key: "getChildTrie",
    value: function getChildTrie(key) {
      var map = this.weakness && isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
      var child = map.get(key);
      if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
      return child;
    }
  }]);
}();
function isObjRef(value) {
  switch (typeof value) {
    case "object":
      if (value === null) break;
    // Fall through to return true...
    case "function":
      return true;
  }
  return false;
}